import {
  Box,
  Button,
  Grid,
  IconButton,
  Paper,
  TextField,
  Typography,
  Tooltip,
  CircularProgress,
  FormControl,
  FormHelperText,
  TextareaAutosize,
} from "@mui/material";
import { createStyles, makeStyles } from "@mui/styles";
import React, { useState } from "react";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { convertBase64, getUserData } from "../../../Base/helper/baseFunctions";
import { UploadTaxDeclarationProofHelper } from "../../helper/TaxDeclarationHelper";
import CancelIcon from "@mui/icons-material/Cancel";
import { v4 as uuidv4 } from "uuid";
import { toast } from "react-toastify";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

const TDStep1 = ({
  handleInputChange,
  step1,
  setStep1,
  stepUpdate1,
  setStepUpdate1,
  activeStep,
  setActiveStep,
  disableEdit = false,
  toggleState,
  toggleDeclarationState,
  checkViewType,
  defaultValue,
  comments,
  setComments,
  fileProof,
  setFileProof,
  handleView,
  checkDeclarationStatus,
}) => {
  const useStyles = makeStyles((theme) =>
    createStyles({
      paper: {
        boxShadow:
          "0px 3px 3px -2px #cbc3c3, 0px 3px 4px 0px rgb(242 242 242), 0px 1px 8px 0px rgb(242 242 242)",
        padding: "10px 20px",
        borderRadius: "10px",
        display: "flex",
        alignItems: "center",
        gap: "8px",
        justifyContent: "space-between",
        width: "100%",
      },
    })
  );
  const classes = useStyles();
  const headerTypographyStyle = {
    fontWeight: "bold",
    textAlign: "center",
    fontSize: "14px",
    color: "black",
  };
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [selectedRow, setSelectedRow] = useState(null);

  const handleMenuClick = (event, rowKey) => {
    setAnchorEl(event.currentTarget);
    setSelectedRow(rowKey);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const fields = [
    {
      name: "et_80c_lip",
      desc: "Payment of Life Insurance Premium (For self, spouse & children)",
      label: "80C - LIP",
    },
    {
      name: "et_80c_ulip", // new
      desc: "Contribution to Unit Linked Insurance Plan (For self, spouse & children)",
      label: "80C - ULIP",
    },
    {
      name: "et_80ccc_pension", // new
      desc: "Contribution to Pension Plans (Self)",
      label: "80CCC - PENSION",
    },
    // {
    //   name: "et_80c_epf", // remove
    //   desc: "Employee Provident Fund (EPF) contributions",
    //   label: "80C - EPF",
    // },
    {
      name: "et_80c_ppf",
      desc: "Deposit in Public Provident Fund (PPF) (For self, spouse & children)",
      label: "80C - PPF",
    },
    {
      name: "et_80c_nsc",
      desc: "Purchase of National Savings Certificate (Self)",
      label: "80C - NSC",
    },
    {
      name: "et_80c_elss",
      desc: "Contribution to Equity Linked Savings Scheme - TAX SAVER-MF (Self)",
      label: "80C - ELSS",
    },
    {
      name: "et_80c_sukanya",
      desc: "Sukanya Samriddhi Scheme (For girl child)",
      label: "80C - SUKANYA",
    },
    {
      name: "et_80c_fd",
      desc: "Fixed Deposit for 5 years with a Scheduled Bank (Tax Saver - Self)",
      label: "80C - FD",
    },
    // {
    //   name: "et_80c_scss", // remove
    //   desc: "Senior Citizens Savings Scheme (SCSS) investments",
    //   label: "80C - SCSS",
    // },
    {
      name: "et_80c_fees",
      desc: "Payment of tuition fees for children for any School, College, University or Educational Institution (Self)",
      label: "80C - FEES",
    },
    {
      name: "et_80c_hlp",
      desc: "Housing Loan Principal (Amount will auto-populate after updating 'Loss from House Property' Section)",
      label: "80C - HLP",
    },
    {
      name: "et_80c_stamp_duty",
      desc: "Stamp Duty/Registration Charges paid for new House Property",
      label: "80C - STAMP_DUTY",
    },
    // {
    //   name: "et_80c_sa_fund", // remove
    //   desc: "Contribution towards Approved Superannuation Fund",
    //   label: "80C - SF",
    // },
    // {
    //   name: "et_80c_nhb",  // remove
    //   desc: "Subscription to any deposit scheme/pension fund of the National Housing Bank (NHB)",
    //   label: "80C - NHB",
    // },
    // {
    //   name: "et_80c_nabard", // remove
    //   desc: "Subscription to bonds issued by the National Bank for Agriculture and Rural Development (NABARD)",
    //   label: "80C - NABARD",
    // },
  ];
  const [uploadStatus, setUploadStatus] = useState({});
  const [files, setFiles] = useState([]);
  const { show, disable_ap } = checkDeclarationStatus || {};
  const [errors, setErrors] = useState({});
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    const rawValue = value.replace(/,/g, "");
    if (rawValue === "" ||  /^\d*\.?\d*$/.test(rawValue)) {
      setStep1({ ...step1, [name]: +rawValue });
    }
    setErrors((prevErrors) => ({
      ...prevErrors,
      total: null,
    }));
  };
  const handleUpdateChange = (e) => {
    const { name, value } = e.target;
    const rawValue = value.replace(/,/g, "");
    if (rawValue === "" ||  /^\d*\.?\d*$/.test(rawValue)) {
      setStepUpdate1({ ...stepUpdate1, [name]: +rawValue });
    }
  };
  const handleSubmit = () => {
    const total = calculateTotal();

    // Validation: Check if total exceeds 15 lakhs
    if (total > 150000) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        total: "Section 80C limit is ₹1.50 lakhs.",
      }));
      return;
    }

    setErrors((prevErrors) => ({
      ...prevErrors,
      total: null,
    }));
    handleInputChange({ target: { name: "tds1", value: step1 } });
    setActiveStep(activeStep + 1);
  };
  const calculateTotal = () => {
    return Object.values(step1).reduce(
      (acc, value) => acc + (parseFloat(value) || 0),
      0
    );
  };
  const calculateTotal2 = () => {
    return Object.values(stepUpdate1).reduce(
      (acc, value) => acc + (parseFloat(value) || 0),
      0
    );
  };

  const handleFileUpload = async (event, name) => {
    const userData = getUserData();
    const file = event.target.files[0];
    if (file) {
      try {
        const allowedMimeTypes = [
          "application/pdf",
          "application/msword",
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        ];
        if (!allowedMimeTypes.includes(file.type)) {
          toast.error(
            "Invalid File type. Accepted file types: .pdf, .doc, .docx",
            {
              duration: 2000,
            }
          );
          return;
        }
        const b64string = await convertBase64(file);

        const ext = file?.name?.split(".").at(-1).toLowerCase();
        const content_type = file.type;
        const filename =
          `${userData?.domain}/Payroll/EmployeeTDProof/` +
          uuidv4() +
          "." +
          name +
          "." +
          ext;

        setFiles((prev) => [
          ...prev,
          {
            b64string,
            filename,
            content_type,
            td_component: name,
          },
        ]);
        setUploadStatus((prev) => ({
          ...prev,
          [name]: "uploaded",
        }));
      } catch (error) {
        console.error("Error during file upload: ", error);
      }
    }
  };

  const handleDeselectFile = (name) => {
    setFiles((prev) => prev.filter((file) => file.td_component !== name));
    setUploadStatus((prev) => ({
      ...prev,
      [name]: null,
    }));
  };

  const handleSaveDocs = async (name, files) => {
    const fileToSave = files.find((file) => file?.td_component === name);
    setUploadStatus((prev) => ({
      ...prev,
      [name]: "loading",
    }));
    if (fileToSave) {
      try {
        const res = await UploadTaxDeclarationProofHelper({
          ...fileToSave,
          old_file_path: fileProof[fileToSave?.td_component],
        });

        if (res?.data?.statuscode === 200) {
          setFileProof((prev) => ({
            ...prev,
            [fileToSave?.td_component]: res?.data?.data?.[0]?.cloud_file,
          }));
        }
      } finally {
        setUploadStatus((prev) => ({
          ...prev,
          [name]: null,
        }));
        setFiles((prev) => prev.filter((file) => file.td_component !== name));
      }
    } else {
      setUploadStatus((prev) => ({
        ...prev,
        [name]: null,
      }));
    }
  };
  return (
    <Box>
      <Typography variant="h6">
        Section 80C - Maximum Eligible deduction Rs 1.50 lakhs
      </Typography>
      {/* Header Row */}
      {(checkViewType || show) && (
        <Grid
          container
          width={"100%"}
          sx={{ padding: "4px 8px", marginBottom: "4px" }}
        >
          <Box
            sx={{
              width: "98%",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-around",
              textAlign: "center",
            }}
          >
            <Box width={"60%"} pr={1}>
              <Typography sx={headerTypographyStyle}></Typography>
            </Box>
            <Box width={"15%"}>
              <Typography sx={headerTypographyStyle}>Declared</Typography>
            </Box>
            {(checkViewType || show) && (
              <Box width={"15%"}>
                <Typography sx={{ ...headerTypographyStyle, ml: "-15px" }}>
                  Approved
                </Typography>
              </Box>
            )}
            <Box width={"10%"} display="flex" justifyContent="space-around">
              <Typography sx={headerTypographyStyle}>Preview Proof</Typography>
            </Box>
            <Box width={"30%"}>
              <Typography sx={{ ...headerTypographyStyle, ml: "-20px" }}>
                Comment
              </Typography>
            </Box>
          </Box>
        </Grid>
      )}
      <Grid container>
        {fields.map((data, id) => {
          return (
            <React.Fragment key={id}>
              {!disableEdit ? (
                <Grid
                  item
                  key={id}
                  width={"100%"}
                  sx={{ padding: "4px 8px", marginBottom: "4px" }}
                >
                  <Paper className={classes.paper}>
                    <Box width={"60%"}>
                      <Typography variant="h6" color={"inherit"}>
                        {data?.label}
                      </Typography>
                      <Typography variant="body2" color={"inherit"}>
                        {data?.desc}
                      </Typography>
                    </Box>
                    {/* Declaration Field */}
                    <Box width={"15%"}>
                      <TextField
                        size="small"
                        type="text"
                        disabled={
                          toggleDeclarationState || checkViewType || disable_ap
                        }
                        autoComplete="first_name"
                        onChange={handleChange}
                        name={data?.name}
                        label={data?.label}
                        placeholder="Enter Amount"
                        fullWidth
                        value={step1?.[data?.name] ? Number(step1?.[data?.name]).toLocaleString("en-IN") : ""}
                        onWheel={(e) => e.target.blur()}
                        sx={{
                          backgroundColor:
                            toggleDeclarationState ||
                            checkViewType ||
                            disable_ap
                              ? "transparent"
                              : "#ffffff",
                          borderRadius: "10px",
                          "& input::placeholder": {
                            fontSize: "12px",
                            color: "#aaa",
                          },
                          "& .MuiInputLabel-root": {
                            fontSize: "12px",
                          },
                        }}
                      />
                    </Box>
                    {/* Approved Field */}
                    {(checkViewType || show) && (
                      <Box width={"15%"} borderRadius={"10px"}>
                        <TextField
                          size="small"
                          type="text"
                          disabled={!checkViewType}
                          autoComplete="first_name"
                          onChange={handleUpdateChange}
                          name={`${data?.name}_approved`}
                          label={data?.label}
                          placeholder="Enter Amount"
                          fullWidth
                          value={stepUpdate1?.[`${data?.name}_approved`] ? Number(stepUpdate1?.[`${data?.name}_approved`]).toLocaleString("en-IN") : ""}
                          onWheel={(e) => e.target.blur()}
                          sx={{
                            backgroundColor: !checkViewType
                              ? "transparent"
                              : "#ffffff",
                            borderRadius: "10px",
                            "& input::placeholder": {
                              fontSize: "12px",
                              color: "#aaa",
                            },
                            "& .MuiInputLabel-root": {
                              fontSize: "12px",
                            },
                          }}
                        />
                      </Box>
                    )}
                    <Box
                      width={"10%"}
                      display="flex"
                      justifyContent={"space-around"}
                      alignItems={"center"}
                    >
                      <IconButton
                        aria-label="actions"
                        aria-controls={open ? "proof-actions-menu" : undefined}
                        aria-haspopup="true"
                        aria-expanded={open ? "true" : undefined}
                        onClick={(e) => handleMenuClick(e, data?.name)}
                      >
                        <MoreVertIcon />
                      </IconButton>
                      <Menu
                        id="proof-actions-menu"
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleMenuClose}
                        MenuListProps={{
                          "aria-labelledby": "actions-button",
                        }}
                        sx={{
                          "& .MuiPaper-root": {
                            boxShadow: "none",
                          },
                        }}
                      >
                        <MenuItem>
                          {!checkViewType && (
                            <>
                              {!uploadStatus[selectedRow] && (
                                <Tooltip
                                  title={
                                    !toggleState
                                      ? "Proof upload window disabled"
                                      : "Proof Upload"
                                  }
                                >
                                  <Box
                                    display={"flex"}
                                    ml={"-8px"}
                                    alignItems={"center"}
                                  >
                                    <IconButton
                                      color="primary"
                                      component="label"
                                      disabled={
                                        !toggleState ||
                                        uploadStatus[selectedRow] === "uploaded"
                                      }
                                      sx={{
                                        "&:hover": {
                                          backgroundColor: "transparent", // remove hover background
                                        },
                                      }}
                                    >
                                      <CloudUploadIcon sx={{ mr: 1.5 }} />
                                      <Typography sx={{ fontSize: "0.9rem" }}>
                                        Proof Upload
                                      </Typography>
                                      <input
                                        type="file"
                                        hidden
                                        onChange={(event) =>
                                          handleFileUpload(event, selectedRow)
                                        }
                                      />
                                    </IconButton>
                                  </Box>
                                </Tooltip>
                              )}

                              {uploadStatus[selectedRow] === "loading" ? (
                                <CircularProgress
                                  size={24}
                                  sx={{ display: "block", margin: "0 auto" }}
                                />
                              ) : uploadStatus[selectedRow] === "uploaded" ? (
                                <Box
                                  sx={{
                                    width: "100%",
                                    display: "flex",
                                    justifyContent: "space-around",
                                    alignItems: "center",
                                  }}
                                >
                                  <Tooltip title={"Save Proof"}>
                                    <IconButton
                                      sx={{ color: "primary" }}
                                      onClick={() =>
                                        handleSaveDocs(selectedRow, files)
                                      }
                                    >
                                      <CheckCircleIcon color="primary" />
                                    </IconButton>
                                  </Tooltip>
                                  <Tooltip title={"Deselect Proof"}>
                                    <IconButton
                                      sx={{ color: "grey.500" }}
                                      onClick={() =>
                                        handleDeselectFile(selectedRow)
                                      }
                                    >
                                      <CancelIcon />
                                    </IconButton>
                                  </Tooltip>
                                </Box>
                              ) : null}
                            </>
                          )}
                        </MenuItem>
                        <MenuItem
                          onClick={() => handleView(fileProof[selectedRow])}
                          disabled={!fileProof[selectedRow] || !toggleState}
                        >
                          <Tooltip
                            title={
                              !toggleState
                                ? ""
                                : !fileProof[selectedRow]
                                ? "No Attachment"
                                : "View Attachment"
                            }
                          >
                            <Box display="flex" alignItems="center" gap={0.5}>
                              <VisibilityIcon sx={{ mr: 1 }} />
                              <Typography sx={{ fontSize: "0.9rem" }}>
                                {!fileProof[selectedRow]
                                  ? "No Attachment"
                                  : "View Attachment"}
                              </Typography>
                            </Box>
                          </Tooltip>
                        </MenuItem>
                      </Menu>
                    </Box>

                    <Box width={"30%"}>
                      <TextareaAutosize
                        minRows={2}
                        maxRows={3}
                        disabled={!checkViewType}
                        placeholder={
                          checkViewType ? "Enter Comment" : "Comment"
                        }
                        value={comments?.[data?.name] || ""}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (value.length <= 75) {
                            setComments({
                              ...comments,
                              [data?.name]: value,
                            });
                          }
                        }}
                        style={{
                          width: "100%",
                          backgroundColor: checkViewType
                            ? "#ffffff"
                            : "transparent",
                          borderRadius: "10px",
                          padding: "8px",
                          fontSize: "14px",
                          fontFamily: "inherit",
                          border: "1px solid #ccc",
                          resize: "none",
                        }}
                      />
                      {checkViewType && (
                        <Typography
                          variant="caption"
                          sx={{
                            display: "block",
                            textAlign: "right",
                            color: "#888",
                          }}
                        >
                          {comments?.[data?.name]?.length || 0}/75
                        </Typography>
                      )}
                    </Box>
                  </Paper>
                </Grid>
              ) : (
                disableEdit &&
                step1?.[data?.name] !== null &&
                step1?.[data?.name] !== undefined &&
                step1?.[data?.name] !== "" && (
                  <Grid item key={id} xs={12} sm={6} md={6} padding={1.5}>
                    <Paper className={classes.paper}>
                      <Box minHeight={"3rem"} width={"75%"}>
                        <Typography variant="body2" gutterBottom mb={2}>
                          {data?.desc}
                        </Typography>
                      </Box>
                      <Box width={"25%"}>
                        <TextField
                          size="small"
                          type="number"
                          autoComplete="first_name"
                          onChange={handleChange}
                          name={data?.name}
                          label={data?.label}
                          disabled={disableEdit}
                          placeholder="Enter Amount"
                          fullWidth
                          value={step1?.[data?.name] || ""}
                        />
                      </Box>
                    </Paper>
                  </Grid>
                )
              )}
            </React.Fragment>
          );
        })}
      </Grid>

      {!disableEdit && (
        <Grid
          item
          width={"100%"}
          sx={{ padding: "4px 8px", marginBottom: "4px" }}
        >
          <Paper className={classes.paper} sx={{ minHeight: "60px" }}>
            <Box width={"60%"} display={"flex"} alignItems={"center"}>
              <Typography variant="h6">Total</Typography>
            </Box>
            <Box width={"15%"} pr={1}>
              <FormControl fullWidth error={!!errors?.total}>
                <TextField
                  size="small"
                  disabled
                  placeholder="Total"
                  label="Declared"
                  value={Number(calculateTotal()).toLocaleString("en-IN") || "0000"}
                  type="text"
                  sx={{
                    "& .MuiInputBase-input": {
                      fontWeight: "600",
                    },
                  }}
                />
                {errors?.total && (
                  <FormHelperText>{errors.total}</FormHelperText>
                )}
              </FormControl>
            </Box>
            {(checkViewType || show) && (
              <Box width={"15%"}>
                <FormControl fullWidth error={!!errors?.total}>
                  <TextField
                    size="small"
                    disabled
                    placeholder="Total"
                    label="Approved"
                    value={Number(calculateTotal2()).toLocaleString("en-IN") || "0000"}
                    type="text"
                    sx={{
                      "& .MuiInputBase-input": {
                        fontWeight: "600",
                      },
                    }}
                  />
                  {errors?.total && (
                    <FormHelperText>{errors.total}</FormHelperText>
                  )}
                </FormControl>
              </Box>
            )}
            <Box
              width={"10%"}
              display="flex"
              justifyContent={"space-around"}
            ></Box>
            <Box width={"30%"}></Box>
          </Paper>
        </Grid>
      )}
      {!disableEdit && (
        <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
          {activeStep !== 0 && (
            <Button
              sx={{ marginRight: "10px", mt: 3 }}
              type="submit"
              variant="outlined"
              size="medium"
              onClick={() => setActiveStep(activeStep - 1)}
            >
              Back
            </Button>
          )}
          {activeStep < 5 && (
            <Button
              sx={{ marginRight: "10px", mt: 3 }}
              size="medium"
              variant="contained"
              className="mpl-primary-btn"
              onClick={() => handleSubmit()}
            >
              Next
            </Button>
          )}
        </Box>
      )}
    </Box>
  );
};

export default TDStep1;
